function addStyle() {
  if (!document.querySelector('style[data-style="checkout-disable"]')) {
      let style = document.createElement('style');
      style.type = 'text/css';
      style.setAttribute('data-style', 'checkout-disable');
      style.innerHTML = '.Cart__Footer [type="submit"][name="checkout"] { pointer-events: none !important; opacity: 0.6 !important; }';
      document.head.appendChild(style);
  }

  $(`.Cart__Footer [type="submit"][name="checkout"], [type="submit"][name="checkout"]`)?.on("click", e => {
   addStyle();
 })
}

function removeStyle() {
    let style = document.querySelector('style[data-style="checkout-disable"]');
    if (style) {
        document.head.removeChild(style);
    }
}

if(window.location.pathname === '/cart' ) {
    window.addEventListener('cart_changed', () => {
      addStyle();
      setTimeout(() => {
        BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
        BSS_B2B.cart.fixer(BSS_B2B.shopData, 0, 0);
      }, 300)
    })
    
    window.addEventListener('bss_b2b_cart_fixer_done', () => {
      setTimeout(() => {
        removeStyle();
      }, 1000)
    })
}
